import { request } from './client';

export interface Comment {
  id: string;
  docId: string;
  parentId: string | null;
  body: string;
  anchor: string | null;
  resolved: boolean;
  author: { id: string; nickname: string };
  createdAt: string;
  replies?: Comment[];
}

export const commentsApi = {
  list: (docId: string) => request<Comment[]>(`/docs/${docId}/comments`),

  create: (docId: string, data: { body: string; anchor?: string; parentId?: string }) =>
    request<Comment>(`/docs/${docId}/comments`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  update: (docId: string, commentId: string, data: { body: string }) =>
    request<Comment>(`/docs/${docId}/comments/${commentId}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),

  remove: (docId: string, commentId: string) =>
    request<{ ok: boolean }>(`/docs/${docId}/comments/${commentId}`, {
      method: 'DELETE',
    }),

  resolve: (docId: string, commentId: string) =>
    request<{ ok: boolean }>(`/docs/${docId}/comments/${commentId}/resolve`, {
      method: 'POST',
    }),

  unresolve: (docId: string, commentId: string) =>
    request<{ ok: boolean }>(`/docs/${docId}/comments/${commentId}/unresolve`, {
      method: 'POST',
    }),
};